module.exports = __webpack_public_path__ + "static/media/error_img.81365269.png";